import { ref } from 'vue'

/**
 * Module-scoped state, so the header CTA, the hero CTA, and the closing CTA all
 * drive the same dialog without prop-drilling or a store. One landing page does
 * not need Pinia for a single boolean.
 */
const isOpen = ref(false)

/** The element that opened the dialog, so focus can be handed back on close. */
let opener = null

export function useDemoModal() {
  const open = () => {
    opener = typeof document !== 'undefined' ? document.activeElement : null
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
    // Returning focus is what makes the dialog usable by keyboard and screen
    // reader — without it, focus falls back to <body> and position is lost.
    if (opener?.focus) {
      opener.focus()
      opener = null
    }
  }

  return { isOpen, open, close }
}
